'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _q = require('q');

var _q2 = _interopRequireDefault(_q);

var _offerBuilderApi = require('self-service-api/core/api/offerBuilderApi');

var _offerBuilderApi2 = _interopRequireDefault(_offerBuilderApi);

var _quantityUpgradesApi = require('self-service-api/core/api/quantityUpgradesApi');

var _quantityUpgradesApi2 = _interopRequireDefault(_quantityUpgradesApi);

var _createOfferPayload = require('self-service-api/core/utilities/createOfferPayload');

var _createQuantityUpgradesPayload = require('self-service-api/core/utilities/createQuantityUpgradesPayload');

var _validators = require('self-service-api/core/validators');

var _MerchandiseIdLists = require('self-service-api/constants/MerchandiseIdLists');

var MerchandiseIdLists = _interopRequireWildcard(_MerchandiseIdLists);

var _MerchandiseIds = require('self-service-api/constants/MerchandiseIds');

var _getIsProductOwned = require('self-service-api/api/getIsProductOwned');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var isQuantityMerchId = function isQuantityMerchId(merchandiseId) {
  return MerchandiseIdLists.QUANTITY_MERCHANDISE_IDS.indexOf(merchandiseId) !== -1;
};

var getIsQuantityUpgrade = function getIsQuantityUpgrade(_ref) {
  var itemConfigurations = _ref.itemConfigurations;

  if (!itemConfigurations || !itemConfigurations.length) {
    return _q2.default.Promise.resolve(false);
  }

  var isQuantityUpgradePromises = itemConfigurations.map(function (_ref2) {
    var merchandiseId = _ref2.merchandiseId;

    // Add special case for sales starter and sales pro legacy additional seat purchase
    if (merchandiseId === _MerchandiseIds.PRODUCT_SALES_STARTER) {
      return (0, _getIsProductOwned.getIsProductOwned)(_MerchandiseIds.PRODUCT_SALES_STARTER);
    }
    if (merchandiseId === _MerchandiseIds.PRODUCT_SALES_PRO_LEGACY) {
      return (0, _getIsProductOwned.getIsProductOwned)(_MerchandiseIds.PRODUCT_SALES_PRO_LEGACY);
    }
    if (merchandiseId === _MerchandiseIds.PRODUCT_SALES_PRO_BUSINESS_USER) {
      return (0, _getIsProductOwned.getIsProductOwned)(_MerchandiseIds.PRODUCT_SALES_PRO_BUSINESS_USER);
    }
    return _q2.default.Promise.resolve(isQuantityMerchId(merchandiseId));
  });

  return _q2.default.Promise.all(isQuantityUpgradePromises).then(function (isQuantityUpgrade) {
    return isQuantityUpgrade.every(function (upgrade) {
      return !!upgrade;
    });
  });
};

var getPurchaseOrderId = function getPurchaseOrderId(purchaseConfig) {
  (0, _validators.validatePurchaseConfig)(purchaseConfig);

  var termId = purchaseConfig.termId,
      currencyCode = purchaseConfig.currencyCode,
      itemConfigurations = purchaseConfig.itemConfigurations,
      productBasedOffers = purchaseConfig.productBasedOffers;


  return getIsQuantityUpgrade(purchaseConfig).then(function (isQuantityUpgrade) {
    if (isQuantityUpgrade) {
      var quantityUpgradesPayload = (0, _createQuantityUpgradesPayload.createQuantityUpgradesPayload)(itemConfigurations);

      return _quantityUpgradesApi2.default.post(quantityUpgradesPayload);
    }

    var offerPayload = (0, _createOfferPayload.createOfferPayload)({
      termId: termId,
      itemConfigurations: itemConfigurations,
      productBasedOffers: productBasedOffers
    });

    return _offerBuilderApi2.default.put({ currencyCode: currencyCode, offerPayload: offerPayload }).then(function (response) {
      return response.id;
    });
  });
};

exports.default = getPurchaseOrderId;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/self-service-api/static-1.837/js/api/getPurchaseOrderId.js
// module id = 584
// module chunks = 3 4 5